import Vue from 'vue';
import App from './App.vue';

import ApiVue from '@/plugins/Api';
Vue.use(ApiVue);

import $config from '@/services/config';

import OAuth2Vue from '@/plugins/OAuth2';
Vue.use(OAuth2Vue, {
  config: {
    client_id: $config.get('client_id'),
    client_secret: $config.get('client_secret'),
  },
});

import StorageVue from '@/plugins/Storage';
Vue.use(StorageVue);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount('#app');

import(/* webpackChunkName: "css-style" */'@/assets/scss/style.scss');
